<div>
  <header>
    <span>URL</span>
    <button (click)="closedialog()" aria-label="Close Dialog" class="button-icon button-ghost">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <form [formGroup]="urlForm" (ngSubmit)="createFile()">
    <mat-dialog-content class="mat-typography mat-dailog-cont-color-padding">
      <p>
        <mat-form-field style="width: 100%">
          <mat-label>URL</mat-label>
          <textarea matInput placeholder="Enter the Url" formControlName="url"></textarea>
        </mat-form-field>
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <mds-button aria-label="Save" role="button" type="primary">Save</mds-button>
    </mat-dialog-actions>
  </form>
</div>
